import { render, staticRenderFns } from "./images-input.vue?vue&type=template&id=af87a2e6&"
import script from "./images-input.vue?vue&type=script&lang=js&"
export * from "./images-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports